(() => {
  const selector = '.product-about__accordion-title';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function contentFor(title) {
    const sibling = title.nextElementSibling;
    return sibling && sibling.classList.contains('product-about__accordion-content') ? sibling : null;
  }

  function finish(content, isOpen) {
    content.style.overflow = '';
    content.style.height = isOpen ? 'auto' : '0';
    if (!isOpen) content.style.display = 'none';
  }

  function setOpen(title, shouldOpen) {
    const content = contentFor(title);
    if (!content) return;

    if (content._accordionAnimation) {
      content._accordionAnimation.cancel();
      content._accordionAnimation = null;
    }

    title.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    title.classList.toggle('active', shouldOpen);
    title.parentElement?.classList.toggle('active', shouldOpen);

    if (reducedMotion || !content.animate) {
      content.style.display = shouldOpen ? 'block' : 'none';
      finish(content, shouldOpen);
      return;
    }

    content.style.overflow = 'hidden';

    if (shouldOpen) {
      content.style.display = 'block';
      content.style.height = 'auto';
      const endHeight = content.scrollHeight;
      content.style.height = '0';
      content._accordionAnimation = content.animate(
        [{ height: '0px', opacity: 0 }, { height: endHeight + 'px', opacity: 1 }],
        { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
    } else {
      const startHeight = content.getBoundingClientRect().height || content.scrollHeight;
      content._accordionAnimation = content.animate(
        [{ height: startHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: 220, easing: 'cubic-bezier(.4,0,.2,1)' }
      );
    }

    const animation = content._accordionAnimation;
    animation.onfinish = () => {
      if (content._accordionAnimation !== animation) return;
      content._accordionAnimation = null;
      finish(content, shouldOpen);
    };
    animation.oncancel = () => {
      if (content._accordionAnimation === animation) content._accordionAnimation = null;
    };
  }

  function toggle(title) {
    const shouldOpen = title.getAttribute('aria-expanded') !== 'true';

    if (shouldOpen) {
      document.querySelectorAll(selector + '[aria-expanded="true"]').forEach((other) => {
        if (other !== title) setOpen(other, false);
      });
    }

    setOpen(title, shouldOpen);
  }

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach((title) => {
      if (!title.hasAttribute('role')) title.setAttribute('role', 'button');
      if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '0');
      if (!title.hasAttribute('aria-expanded')) title.setAttribute('aria-expanded', 'false');

      const content = contentFor(title);
      if (content && title.getAttribute('aria-expanded') !== 'true') {
        content.style.display = 'none';
        content.style.height = '0';
      }
    });
  }

  document.addEventListener('click', (event) => {
    const title = event.target.closest(selector);
    if (!title) return;
    event.preventDefault();
    toggle(title);
  });

  document.addEventListener('keydown', (event) => {
    const title = event.target.closest(selector);
    if (!title || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    toggle(title);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();